import { useState, useEffect, useCallback } from 'react';
import { supabase } from '../lib/supabase';
import { subscribeShiftChanges } from '../lib/realtime';
import type { DrivingSession } from '../lib/types';

export function useDrivingSessions(driverId: string | undefined) {
  const [sessions, setSessions] = useState<DrivingSession[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const refetch = useCallback(async () => {
    if (!driverId) return;
    const { data, error: err } = await supabase
      .from('driving_sessions')
      .select('*, breaks(*)')
      .eq('driver_id', driverId)
      .order('started_at', { ascending: false });
    if (err) setError(err.message);
    else setSessions((data ?? []) as DrivingSession[]);
    setLoading(false);
  }, [driverId]);

  useEffect(() => {
    if (!driverId) {
      setLoading(false);
      return;
    }
    setLoading(true);
    refetch();
    const unsub = subscribeShiftChanges(driverId, refetch);
    return unsub;
  }, [driverId, refetch]);

  return { sessions, loading, error, refetch };
}
